import { render, staticRenderFns } from "./WheelBattleConsumerHeader.vue?vue&type=template&id=06283f04&scoped=true&"
import script from "./WheelBattleConsumerHeader.vue?vue&type=script&lang=js&"
export * from "./WheelBattleConsumerHeader.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleConsumerHeader.vue?vue&type=style&index=0&id=06283f04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06283f04",
  null
  
)

export default component.exports